var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStripePendingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 19.5,
    r: 19.5,
    fill: "#ff6633"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8889 27.8336C24.4913 27.8336 28.2222 24.1026 28.2222 19.5003C28.2222 14.8979 24.4913 11.1669 19.8889 11.1669C15.2865 11.1669 11.5556 14.8979 11.5556 19.5003H13.66C14.1776 19.5003 14.501 20.0264 14.2423 20.4472L10.7489 26.1291C10.4901 26.5499 9.84321 26.5499 9.58444 26.1291L6.09107 20.4472C5.83231 20.0264 6.15577 19.5003 6.6733 19.5003H8.77778C8.77778 13.3638 13.7524 8.38916 19.8889 8.38916C26.0254 8.38916 31 13.3638 31 19.5003C31 25.6368 26.0254 30.6114 19.8889 30.6114C19.1218 30.6114 18.5 29.9896 18.5 29.2225C18.5 28.4554 19.1218 27.8336 19.8889 27.8336Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8889 12.5557C20.656 12.5557 21.2778 13.1775 21.2778 13.9446V19.5001C21.2778 20.2672 20.656 20.889 19.8889 20.889C19.1218 20.889 18.5 20.2672 18.5 19.5001V13.9446C18.5 13.1775 19.1218 12.5557 19.8889 12.5557Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9068 18.5184C19.4492 17.976 20.3286 17.976 20.871 18.5184L23.8172 21.4647C24.3596 22.0071 24.3596 22.8865 23.8172 23.4289C23.2748 23.9713 22.3954 23.9713 21.8531 23.4289L18.9068 20.4826C18.3644 19.9402 18.3644 19.0608 18.9068 18.5184Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStripePendingIcon);
export default __webpack_public_path__ + "static/media/stripe-pending-icon.7008ddf406a0989a5d0c74736109301f.svg";
export { ForwardRef as ReactComponent };